/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserNamespaceAuthorizationKey } from './userNamespaceAuthorizationKey';


export interface UserNamespaceAuthorizationCreateRequest { 
    userNamespaceAuthorizationKey: UserNamespaceAuthorizationKey;
    /**
     * The list of namespace permissions
     */
    namespacePermissions?: Array<UserNamespaceAuthorizationCreateRequest.NamespacePermissionsEnum>;
}
export namespace UserNamespaceAuthorizationCreateRequest {
    export type NamespacePermissionsEnum = 'READ' | 'WRITE' | 'EXECUTE' | 'GRANT' | 'WRITE_DESCRIPTIVE_CONTENT' | 'WRITE_ATTRIBUTE';
    export const NamespacePermissionsEnum = {
        READ: 'READ' as NamespacePermissionsEnum,
        WRITE: 'WRITE' as NamespacePermissionsEnum,
        EXECUTE: 'EXECUTE' as NamespacePermissionsEnum,
        GRANT: 'GRANT' as NamespacePermissionsEnum,
        WRITEDESCRIPTIVECONTENT: 'WRITE_DESCRIPTIVE_CONTENT' as NamespacePermissionsEnum,
        WRITEATTRIBUTE: 'WRITE_ATTRIBUTE' as NamespacePermissionsEnum
    };
}
